module.exports = __webpack_public_path__ + "static/media/buttons-icon-buttons-24-more-red.81c5273b.svg";